import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const Evaluation = {
  updateEvaluationById: (id) =>
    request.get(`/evaluation/id/${id}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getEvaluations: () =>
    request.get("/evaluation", {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default Evaluation;
